import { AppState } from '@app/ngrx/app-state/app-state';
import { createSelector } from '@ngrx/store';

export const getCountryState = (state: AppState) => state.country;

export const getCurrentCountry = createSelector(getCountryState, (state) => state.currentCountry);
